import {
  Component,
  ComponentRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { RxComposite } from '../model/rx-composite';
import { RxInputComponent } from '@nrwl/rx-input';

@Component({
  selector: 'nrwl-rx-new-group-composite',
  templateUrl: './rx-new-group-composite.component.html',
  styleUrls: ['./rx-new-group-composite.component.scss'],
})
export class RxNewGroupCompositeComponent extends RxComposite implements OnInit {
  componentRef: ComponentRef<any>;
  @ViewChild('container', { read: ViewContainerRef, static: true }) container;

  constructor() {
    super();
  }

  ngOnInit() {
    this.payload.fields.forEach((field) => {
      this.componentRef = this.container.createComponent(RxInputComponent);
      this.componentRef.instance.payload = field;
    });
  }
}
